import { useEffect, useState } from "react";
import { Collapse, NavDropdown } from "@/utils/bootstrap";
import useIsRtl from "@/hooks/useIsRtl";

interface Props {
  children: any;
  title: any;
  down: boolean;
  onSelect?: (e: any) => void;
  reversed?: boolean;
  setRotate?: (rotate: boolean) => void;
  HoverDropDownCollapseStyle?: React.CSSProperties;
}

const HoverDropDown: React.FC<Props> = ({
  children,
  title,
  down,
  onSelect,
  reversed = false,
  setRotate,
  HoverDropDownCollapseStyle,
}) => {
  const [show, setShow] = useState(false);
  // const router = useRouter();
  const isRTL = useIsRtl();
  const align = (isRTL && !reversed) || (!isRTL && reversed) ? "end" : "start";
  const drop = down ? "down" : isRTL ? "start" : "end";
  let className = !down ? "not-down" : isRTL ? "r-pointer" : "l-pointer";
  if (reversed && down) className = isRTL ? "l-pointer" : "r-pointer";
  useEffect(
    () => {
      setRotate?.(show);
    },
    [show], // eslint-disable-line react-hooks/exhaustive-deps
  );
  return (
    <NavDropdown
      onClick={(e) => e.stopPropagation()}
      align={align}
      onSelect={(e) => {
        setShow(false);
        onSelect?.(e);
      }}
      className={className}
      title={title}
      renderMenuOnMount={true}
      show={show}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      drop={drop}
    >
      {down ? (
        <Collapse in={show} dimension={"height"}>
          <div
            style={{
              height: "fit-content",
              ...HoverDropDownCollapseStyle,
            }}
          >
            {children}
          </div>
        </Collapse>
      ) : (
        children
      )}
    </NavDropdown>
  );
};

export default HoverDropDown;
